import * as Sentry from '@sentry/browser';
import React, { useEffect, useState } from 'react';
import { Text } from '../../ui';
import API, { ResumeMetrics } from '../../utils/api';

const ResumeMetricsComponent = ({ resumeId }: { resumeId: string }) => {
  const [metrics, setMetrics] = useState<ResumeMetrics>();

  useEffect(() => {
    API.resume
      .getMetrics(resumeId)
      .then((metrics) => setMetrics(metrics))
      .catch((error) => {
        Sentry.captureException(error, { tags: { noFeedback: true } });
      });
  }, [resumeId]);

  if (metrics && metrics.viewsToday === 0 && metrics.viewsThisWeek === 0) {
    return (
      <Text variant="captionDark" color="white50">
        No views this week
      </Text>
    );
  }

  if (metrics) {
    return (
      <Text variant="captionDark" color="white50">
        {`${metrics.viewsToday} views today, ${metrics.viewsThisWeek} this week`}
      </Text>
    );
  }

  return (
    <Text variant="captionDark" color="white50">
      Loading...
    </Text>
  );
};

export default ResumeMetricsComponent;
